import { render, staticRenderFns } from "./Denounce-menu.vue?vue&type=template&id=038f20f1&scoped=true"
import script from "./Denounce-menu.vue?vue&type=script&lang=js"
export * from "./Denounce-menu.vue?vue&type=script&lang=js"
import style0 from "./Denounce-menu.vue?vue&type=style&index=0&id=038f20f1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "038f20f1",
  null
  
)

export default component.exports